import { breadcrumbsActions } from "@store/breadcrumbs";
import { DataGrid } from "@mui/x-data-grid";
import * as React from "react";
import { Modal, Switch, Button } from "@mui/material";

import { makeStyles } from "@mui/styles";
import { Box } from "@mui/system";

import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ApplicationPageTemplate from "src/applications/dashboard/components/ApplicationPageTemplate/ApplicationPageTemplate";
import { fetchCategory, addNewCategory, toggelDeleteGiftCategory } from "@store/store-category-management";
import { setLoading } from "@store/asset-loader";
import { showErrorMessage, showSuccessMessage } from "@store/dashboard";

import AddCategoryModal from "./AddCategoryModal";

const useStyles = makeStyles((theme) => ({
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		overflow: "scroll",
	},
	modalContent: {
		position: "absolute",
		top: "50%",
		left: "50%",
		transform: "translate(-50%, -50%)",
		backgroundColor: "#fff",
		padding: 16,
		width: "50%",
		overflow: "scroll",
	},
	modalTitle: {
		marginBottom: 10,
	},
	formLabel: {
		display: "in-line",
		marginBottom: 5,
		fontWeight: "bold",
	},
	formInput: {
		width: "100%",
		marginBottom: 10,
		padding: 8,
		border: "1px solid #ccc",
		borderRadius: 4,
		boxSizing: "border-box",
	},
	formCheckbox: {
		marginRight: 8,
	},
	formActions: {
		display: "flex",
		justifyContent: "flex-end",
		marginTop: 10,
	},
}));
const Categories = () => {
	const dispatch = useDispatch();
	const rows = useSelector((state) => state.giftCategoryList.assets);
	const classes = useStyles();
	const [modalOpen, setModalOpen] = useState(false);
	const [selectedImageUrl, setSelectedImageUrl] = useState("");

	const [openModal, setOpenModal] = useState(false);
	const [existingFormData, setExistingFormData] = useState(null);
	const handleOpenModal = (imageUrl) => {
		setSelectedImageUrl(imageUrl);
		setModalOpen(true);
	};

	const handleCloseModal = () => {
		setSelectedImageUrl("");
		setModalOpen(false);
	};
	useEffect(() => {
		dispatch(
			breadcrumbsActions.setBreadcrumbs([
				{ label: "Home", url: "/" },
				{ label: "Gift Category Management", url: "/category-management" },
			])
		);
		dispatch(fetchCategory());
	}, [dispatch]);
	const columns = [
		{
			field: "imageUrl",
			headerName: "Image",
			width: 200,
			height: 200,
			renderCell: (params) => <img src={params.value} alt="background" style={{ width: "100%", height: "100%", objectFit: "contain" }} key={params.id} onClick={() => handleOpenModal(params.value)} />,
		},
		{ field: "title", headerName: "Title", width: 150 },
		{ field: "slug", headerName: "Slug", width: 150 },
		{ field: "id", headerName: "ID", width: 90, hide: true },
		{ field: "country", headerName: "Country", width: 130 },
		{ field: "order", headerName: "Order", type: "number", width: 130 },

		{
			field: "isDeleted",
			headerName: "Active/Inactive",
			width: 120,
			renderCell: (params) => <Switch checked={!params.value} onChange={(event) => handleIsDeletedChange(params.id, event.target.checked)} key={params.id} />,
		},

		{
			field: "actions",
			headerName: "Actions",
			width: 120,
			renderCell: (params) => (
				<Button
					variant="contained"
					color="primary"
					onClick={() => {
						// save changes for this row
						const updatedRowData = { ...params.row };
						console.log("current row", updatedRowData);
						setExistingFormData(updatedRowData);
						setOpenModal(true);
					}}
				>
					Update
				</Button>
			),
		},
		
	];

	const handleOpenModaladd = () => {
		setOpenModal(true);
	};

	const handleCloseModaladd = () => {
		setExistingFormData(null);

		setOpenModal(false);
	};

	const handleAddNew = (data) => {
		dispatch(setLoading(true));
		console.log("Add cat:",data.image)
		const { image, isUpdate, ...CategoryData } = data;
		const request = { CategoryData, image, isUpdate };
		dispatch(addNewCategory(request))
			.then(() => {
				dispatch(setLoading(false));
				console.log("close modal");
				dispatch(handleCloseModaladd());
				return dispatch(showSuccessMessage("Adding New updated successfully"));
			})
			.catch(function (error) {
				console.log(error);
				//dispatch(showErrorMessage(`Failed to update asset: ${error}`));
			});
	};

	const handleIsDeletedChange = (id, checked) => {
		console.log(id, checked);
		dispatch(setLoading(true));

		dispatch(toggelDeleteGiftCategory(id))
			.then(() => {
				dispatch(setLoading(false));
				return dispatch(showSuccessMessage("Gift Category updated successfully"));
			})
			.catch(function (error) {
				console.log(error);
				dispatch(showErrorMessage(`Failed to update Gift Category: ${error}`));
			});
	};

	return (
		<ApplicationPageTemplate title={"Gift Categories Management"} description={"Manage Gift Categories with Add, Update and Activate"} pageReady={true}>
			<div style={{ height: 800, width: "100%" }}>
				<Button variant="contained" color="primary" onClick={handleOpenModaladd}>
					Add New
				</Button>

				<DataGrid groupBy={"country"} rows={rows} rowClassName="fixed-height-cell" rowHeight={120} columns={columns} pageSize={25} />

				<AddCategoryModal isVisible={openModal} onClose={handleCloseModaladd} onCreate={handleAddNew} existingFormData={existingFormData} />

				<Modal className={classes.modal} open={modalOpen} onClose={handleCloseModal}>
					<Box sx={{ width: 300 }}>
						<img src={selectedImageUrl} alt="" style={{ maxHeight: "50%", maxWidth: "100%" }} />
					</Box>
				</Modal>
			</div>
		</ApplicationPageTemplate>
	);
};

export default Categories;
